import axios from 'axios';

export const CommonService = {
  verifyPinCode(pinCode: any) {
    const url = process.env.REACT_APP_API_URL + '/common/verify-pin-code?pinCode=' + pinCode;
    return axios.get(url);
  }
};
